export enum Source {
  prediction = 'prediction',
  realtime = 'realtime',
}

export enum Level {
  low = 'low',
  medium = 'medium',
  high = 'high',
  incomplete = 'incomplete',
  missing = 'missing',
  notpublictransport = 'notpublictransport',
}

export interface IOccupancy {
  level: Level;
  source: Source;
}
